module.exports = __webpack_public_path__ + "media/levelup.618dfce7.mp3";